<template>
    <article class="i-results-table">
        <div class="i-results-table__header">
            <div
                class="i-results-table__year"
                v-html="results.year"></div>
            <simple-select
                v-if="isMobile && headers.length > 1"
                :items="headers"
                @tab-selected="tabSelected" />

            <div
                v-if="isMobile && headers.length === 1"
                class="i-results-table__quarter"
                v-html="currentQuarter"></div>

            <ul
                v-if="!isMobile"
                class="i-results-table__headers">
                <li
                    v-for="(header, i) in headers"
                    :key="i"
                    class="i-results-table__quarter"
                    v-html="header">
                </li>
            </ul>
        </div>
        <div
            v-for="(row, i) in rows"
            :key="i"
            class="i-results-table__row-wrap">
            <ul
                v-if="types.includes(row.name) && row.data && isMobile"
                class="i-results-table__row">
                <li
                    class="i-results-table__item"
                    v-html="row.name">
                </li>
                <li
                    class="i-results-table__item">
                    <a
                        class="i-results-table__link"
                        :href="row.data.file.src"
                        :title="row.data.file.name"
                        target="_blank"
                        v-html="row.data.file.extension.toUpperCase() + ' ' + row.data.file.size"></a>
                </li>
            </ul>
            <ul
                v-if="types.includes(row.name) && !isMobile"
                class="i-results-table__row">
                <li
                    class="i-results-table__item"
                    v-html="row.name">
                </li>
                <div
                    class="i-results-table__items-wrap">
                    <li
                        v-for="(cell, k) in headers"
                        :key="k"
                        class="i-results-table__item">
                        <a
                            v-if="cellItemDesktop(cell, row.name)"
                            class="i-results-table__link"
                            :href="cellItemDesktop(cell, row.name).file.src"
                            :title="cellItemDesktop(cell, row.name).file.name"
                            target="_blank"
                            v-html="cellItemDesktop(cell, row.name).file.extension.toUpperCase() + ' ' + cellItemDesktop(cell, rows[i].name).file.size"></a>
                    </li>
                </div>
            </ul>
        </div>
	    <div
		    v-if="isShowWebcasts"
		    class="i-results-table__row-wrap">
		    <ul class="i-results-table__row">
			    <li class="i-results-table__item">Запись вебкаста</li>
			    <div
				    class="i-results-table__items-wrap">
				    <template v-for="i in 4" :key="`webcast-${results.year}-${5 - i}`">
					    <li
						    v-if="isShowWebcast(results.webcast[`q${5 - i}`], `q${5 - i}`)"
						    class="i-results-table__item _webcast"
					    >
						    <a
							    v-if="results.webcast[`q${5 - i}`]"
							    class="ui-link _icon"
							    :href="results.webcast[`q${5 - i}`]"
							    target="_blank"
						    >
							    <span class="_full">Запись вебкаста</span>
							    <span class="_small">Запись</span>
						    </a>
						    <span v-else>&nbsp;</span>
					    </li>
				    </template>
			    </div>
		    </ul>
	    </div>
    </article>
</template>

<script>
    import SimpleSelect from './SimpleSelect'

    export default {
        name: 'ResultsTable',
        components: {
            SimpleSelect
        },
        data() {
            return {
                currentQuarter: '',
                types: [],
                rows: [],
	            isShowWebcasts: false,
	            curWebcastKey: ''
            }
        },
        props: {
            results: {
                type: Object,
                default: () => {}
            },
	        isReverse: {
		        type: Boolean,
		        default: false
	        }
        },
        computed: {
            isMobile () {
                return window.innerWidth < 768
            },
            headers () {
				const collectedHeaders = [...new Set(this.results.items.map(el => el.quarter))]
                return this.isReverse ? collectedHeaders.sort().reverse() : collectedHeaders.sort()
            },
        },
        methods: {
            tabSelected (quarter) {
				const curQuarterNum = quarter.replace(/\D/g, '')
                this.currentQuarter = quarter
	            this.curWebcastKey = `q${curQuarterNum}`
                this.updateData()
                this.$emit('tab-change')
            },
            getItem (item) {
                return this.results.items.filter(el => el.quarter === this.currentQuarter && el.type === item)[0]
            },
            updateData() {
                this.rows.forEach(element => {
                    element.data = this.getItem(element.name)
                })
            },
            cellItemDesktop (quarter, name) {
                return this.results.items.filter(el => el.quarter === quarter && el.type === name)[0]
            },
	        isShowWebcast(item, key) {
				return !this.isMobile || (key === this.curWebcastKey);
	        }
        },
        created() {
	        this.isShowWebcasts = !!this.results?.webcast && Object.entries(this.results?.webcast).length;
            this.currentQuarter = this.headers[0]
	        const quarterNum = this.currentQuarter.replace(/\D/g, '')
	        this.curWebcastKey = `q${quarterNum}`
            this.types = [...new Set(this.results.items.map(el => el.type))]
            this.types.forEach(el => {
                this.rows.push({name: el, data: null})
            })

            this.updateData()
        },
    }
</script>